// Display-level cleaners for SOP/FAQ document bodies.
// These do not modify the corpus; they only sanitize what the page renders.

const META_LINE_RE = /^[ \t]*Version[ \t]+[0-9.]+[ \t]*\|[ \t]*[A-Z]{2,6}[ \t]+domain[ \t]*\r?\n?/gm;

const DISCLAIMER_RE = /(?:\r?\n\s*)?(?:^|\n)[ \t]*(This document is educational\.[^\n]*)\s*$/;

/**
 * Strip any embedded "Version X.Y | XYZ domain" metadata line and collapse
 * the resulting doubled blank lines. Safety net for future imports.
 */
export function stripEmbeddedMetaLine(body: string): string {
  return body.replace(META_LINE_RE, "").replace(/\n{3,}/g, "\n\n");
}

/**
 * Detect and remove the trailing "This document is educational..." paragraph.
 * Returns { body, disclaimer } — disclaimer is null when no such sentence exists.
 */
export function extractTrailingDisclaimer(body: string): {
  body: string;
  disclaimer: string | null;
} {
  const m = body.match(DISCLAIMER_RE);
  if (!m) return { body, disclaimer: null };
  const disclaimer = m[1].trim();
  const cleaned = body.slice(0, m.index).replace(/\s+$/, "");
  return { body: cleaned, disclaimer };
}
